import { useReactToPrint } from 'react-to-print';
import { useRef } from 'react';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReportsSection from '../../components/ReportDropdown2';
import LocationPicker from '../LocationPicker';
import { db } from "./../../firebase"; 
import { AnimatePresence, motion } from "framer-motion";
import { collection, query, where, getDocs } from 'firebase/firestore';
import { updateProfile } from "firebase/auth";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { FaWhatsapp, FaFacebook, FaTwitter, FaLinkedin, FaEnvelope, FaTimes } from 'react-icons/fa';
import { useCountry } from '../CountryContext';
const Dropdown = ({ type, value, options, onSelect, countryValue }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownMenuRef = useRef(null);
    const contentRef = useRef(null);
    const thumbRef = useRef(null);
    const [thumbHeight, setThumbHeight] = useState(20);
    const [scrollTop, setScrollTop] = useState(0);
    const [isDragging, setIsDragging] = useState(false);
    const [selectedItems, setSelectedItems] = useState({});
  
    // Add your specific options based on the type
    const dropdownOptions = type === "SERVICES" ? [
      { id: "contracts", name: "Contracts", value: "contracts" },
      { id: "calendar", name: "Calendar", value: "calendar" },
      { id: "verification", name: "Verification", value: "verification" },
      { id: "crop-advisory", name: "Crop Advisory", value: "crop-advisory" },
      { id: "livestock-advisory", name: "Livestock Advisory", value: "livestock-advisory" },
      { id: "pest-alert", name: "Pest Alert", value: "pest-alert" },
      { id: "disease-alert", name: "Disease Alert", value: "disease-alert" },
      { id: "credit-score", name: "Credit Score", value: "credit-score" },
      { id: "weather", name: "Weather", value: "weather" }
    ] : options || [];
  
    const capitalizeWords = (str) => {
      if (!str) return "";
      return str
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(" ");
    };
  
    const getDisplayValue = () => {
      if (value) {
        if (type === "COUNTRY") return value.name || "-";
        return value.name || value.value || "-";
      }
      return "-";
    };
  
    const getHeaderTitle = () => {
      switch (type) {
        case "COUNTRY":
          return "Countries";
        case "REGION":
          return "Regions";
        case "DISTRICT":
          return "Districts";
        case "MUNICIPALITY":
          return "Municipalities";
        case "SMMEs":
          return "SMMEs";
        case "VALUE CHAIN":
          return "Value Chains";
        case "PROJECT":
          return "Projects";
        case "USER TYPE":
          return "User Types";
        case "SERVICES":
          return "Services";
        default:
          return "Select Option";
      }
    };
  
    const toggleItemSelection = (itemId) => {
      setSelectedItems(prev => ({
        ...prev,
        [itemId]: !prev[itemId]
      }));
    };
  
    const renderRegularItems = () => {
      return dropdownOptions?.map((option, index) => (
        <li
          key={index}
          className={`group flex items-center justify-between px-3 py-2 text-sm cursor-pointer hover:bg-[#2E453D] transition-colors duration-200 rounded ${
            selectedItems[option.id] ? "bg-[#2E453D]" : ""
          }`}
        >
          <span 
            className="text-white"
            onClick={(e) => {
              e.stopPropagation();
              onSelect(option);
              setIsOpen(false);
            }}
          >
            {option.name || option.value}
          </span>
          <button 
            onClick={(e) => {
              e.stopPropagation();
              toggleItemSelection(option.id);
            }}
          >
            {selectedItems[option.id] ? <SelectedIcon /> : <UnselectedIcon />}
          </button>
        </li>
      ));
    };
  
    const renderGroupedItems = () => {
      return renderRegularItems();
    };
  
    const UnselectedIcon = () => (
      <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8.5" cy="8.5" r="8" fill="#D9D9D9" stroke="none"/>
      </svg>
    );
    
    const SelectedIcon = () => (
      <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8.5" cy="8.5" r="8" fill="#2E453D" stroke="#FFBD26"/>
        <path d="M5 8.5L7.5 11L12 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    );
  
    const handleScroll = () => {
      if (!contentRef.current) return;
      const { scrollTop, scrollHeight, clientHeight } = contentRef.current;
      setScrollTop(scrollTop);
      
      const thumbH = Math.max(
        (clientHeight / scrollHeight) * clientHeight,
        20
      );
      setThumbHeight(thumbH);
    };
  
    const handleTrackClick = (e) => {
      if (!contentRef.current || !thumbRef.current) return;
      const trackRect = e.currentTarget.getBoundingClientRect();
      const thumbOffset = e.clientY - trackRect.top - thumbHeight / 2;
      const scrollPercentage = thumbOffset / (trackRect.height - thumbHeight);
      contentRef.current.scrollTop =
        scrollPercentage * (contentRef.current.scrollHeight - contentRef.current.clientHeight);
    };
  
    const handleThumbMouseDown = (e) => {
      e.preventDefault();
      setIsDragging(true);
      
      const startY = e.clientY;
      const startScrollTop = scrollTop;
      
      const handleMouseMove = (e) => {
        if (!isDragging || !contentRef.current) return;
        const deltaY = e.clientY - startY;
        const trackHeight = contentRef.current.clientHeight - thumbHeight;
        const scrollDelta = (deltaY / trackHeight) * contentRef.current.scrollHeight;
        contentRef.current.scrollTop = startScrollTop + scrollDelta;
      };
      
      const handleMouseUp = () => {
        setIsDragging(false);
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
      };
      
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
    };
  
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropdownMenuRef.current && !dropdownMenuRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);
  
    useEffect(() => {
      if (contentRef.current) {
        handleScroll();
      }
    }, [isOpen, options]);
  
    return (
        <div className="relative md:mr-4 mr-2" ref={dropdownMenuRef}>
        <button
          className={`relative xl:w-[205px] lg:w-[160px] md:w-[100px] w-[70px] h-[20px] md:h-[53px] bg-[#2E453D] text-white flex justify-between items-center text-[8px] md:text-[17px] px-[2px] rounded-[4px] truncate`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className={`whitespace-normal break-words font-normal leading-[0.90] text-center capitalize w-full ${
            getDisplayValue() === "-" ? "text-gray-400" : ""
          }`}>
            {capitalizeWords(getDisplayValue())}
          </span>
          
          <span className="absolute bottom-[1px] right-3 text-[6px] md:text-[8px] text-white">
            {(type === "COUNTRY" && value?.code) || 
             (type === "REGION" && value?.value) || 
             (type === "DISTRICT" && value?.value) || 
             (type === "SMMEs" && value?.value) || 
             '-'}
          </span>
          
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751799445/Expand_down_light_syoynq.png"
            alt="expand"
            className="absolute bottom-2 right-2 w-2 h-2 md:w-5 md:h-5"
          />
        </button>
  
        <AnimatePresence>
          {isOpen && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.2, ease: "easeInOut" }}
              className="bg-[#2E453D]/80 rounded-b-[5px] overflow-hidden backdrop-blur-sm absolute top-full mt-1 left-0 w-full z-50 md:w-[205px]"
            >
              <div className="px-3 py-2">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-white text-sm font-semibold">
                    {getHeaderTitle()}
                  </h3>
                  <img 
                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1750628487/Export_light_kuxwb6.png" 
                    alt="Export icon"
                    className="w-4 h-4 ml-2 cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsOpen(false);
                    }}
                  />
                </div>
                <div className="custom-scroll-area max-h-[200px]">
                  <div
                    className="custom-scroll-content"
                    ref={contentRef}
                    onScroll={handleScroll}
                  >
                    <ul className="space-y-2">
                      {type === "SMMEs" || type === "TYPE OF FARMING" 
                        ? renderGroupedItems()
                        : renderRegularItems()}
                    </ul>
                  </div>
                  <div className="custom-scroll-track" onClick={handleTrackClick}>
                    <div
                      ref={thumbRef}
                      className="custom-scroll-thumb"
                      style={{
                        height: `${thumbHeight}px`,
                        top: `${scrollTop}px`,
                        cursor: isDragging ? "grabbing" : "grab",
                      }}
                      onMouseDown={handleThumbMouseDown}
                    ></div>
                  </div>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    );
  };
const Verification = () => {
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState('');
  const { state } = useLocation();

  const [searchResults, setSearchResults] = useState(null);
  const [searchError, setSearchError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [pdfDownloaded, setPdfDownloaded] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const pdfRef = useRef();
  console.log('Received productBoxValues in PDFPreview:', location.state?.productBoxValues || []);
  const [showSharePopup, setShowSharePopup] = useState(false);
  const { selectedCountry } = useCountry() || {};
  const handleShare = async (platform) => {
    if (!pdfDownloaded) {
      alert('Please download the PDF first before sharing');
      return;
    }
    
    const pdfUrl = `Registration_${registrationNumber || 'Document'}.pdf`;
    const shareText = `Please check out my registration document: ${pdfUrl}`;
    
    switch(platform) {
      case 'whatsapp':
        window.open(`https://wa.me/?text=${encodeURIComponent(shareText)}`, '_blank');
        break;
      case 'facebook':
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(pdfUrl)}`, '_blank');
        break;
      case 'twitter':
        window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}`, '_blank');
        break;
      case 'linkedin':
        window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(pdfUrl)}&title=${encodeURIComponent('Registration Document')}&summary=${encodeURIComponent(shareText)}`, '_blank');
        break;
      case 'email':
        window.open(`mailto:?subject=Registration Document&body=${encodeURIComponent(shareText)}`);
        break;
      default:
        break;
    }
  };


  const displayData = searchResults || location.state || {};

  const {
    personalInfo = {},
    organizationInfo = {},
    dropdownSelections = {},
    reportSelections: initialReportSelections = {
      COUNTRY: "--",
      REGION: "--",
      DISTRICT: "--",
      MUNICIPALITY: "--",
      SMMEs: "--",
      "VALUE CHAIN": "--",
      "TYPE OF FARMING": "--",
      "USER TYPE": "--"
    },
    selectedLanguage = null,
    landData = {},
    selectedSkills = [],
    membershipData = {
      selected: [],
      custom: [],
      customInputBoxes: [],
      inputs: {}
    },
    groupExperience = {},
    dataPermissions = {},
    personData = {},
    focusSelected = [],
    sectionD = {},
    industry = {},
    productBoxValues = Array(8).fill({
      minOrder: 0,
      minOrderUnit: 'Kg',
      size: 'Regular',
      farmGatePrice: 0,
      farmGatePriceUnit: 'Kg'
    }),
    setaQualification = {},
    location: userLocation = null,
    registrationNumber = '',
    idDocumentUrl = '',
    profileImage = null,
    productImages = [],
    certificatesUrls = [],
    formData,
    orgType = ''
  } = displayData;

  const safeFormData = {
    firstName: '',
    surname: '',
    mobile: '',
    email: '',
    physicalAddress: '',
    idNumber: '',
    ...formData
  };

  const safeLandData = {
    type1: landData?.type1 || { type: "", size: "", unit: "" },
    type2: landData?.type2 || { type: "", size: "", unit: "" },
    erfNumber: landData?.erfNumber || ''
  };

  const safeSectionD = {
    focusSelected: focusSelected || [],
    selectedType: sectionD.selectedType || '',
    selectedOption: sectionD.selectedOption || '',
    selectedCategories: sectionD.selectedCategories || [],
    ...sectionD
  };

  const safeIndustry = {
    selectedChallenges: (industry.selectedChallenges || []).map(challenge => {
      if (typeof challenge === 'string') {
        return {
          title: challenge,
          description: '',
          solution: ''
        };
      }
      return {
        id: challenge.id || "",
        title: challenge.title || "Not provided",
        description: challenge.description || "",
        solution: challenge.solution || "",
        code: challenge.code || ""
      };
    }),
    vision: industry.vision || 'Not provided'
  };
  
  const safeSetaQualification = {
    selectedS: setaQualification.selectedS || '',
    selectedQ: setaQualification.selectedQ || '',
    ...setaQualification
  };
  const safeMembershipData = {
    selected: membershipData?.selected || [],
    custom: Array.isArray(membershipData?.custom) 
      ? membershipData.custom.filter(Boolean)
      : membershipData?.custom 
        ? [membershipData.custom]
        : [],
    customInputBoxes: membershipData?.customInputBoxes || [],
    inputs: membershipData?.inputs || {}
  };

  const [imageStatus, setImageStatus] = useState({
    profile: { loaded: false, url: null },
    products: productImages.map(img => ({ 
      loaded: false, 
      url: img.url || img.previewUrl || img.cloudinaryUrl || null 
    })),
    certificates: certificatesUrls.map(cert => ({ 
      loaded: false, 
      url: cert.url || cert.previewUrl || cert.cloudinaryUrl || null 
    }))
  });

  const reportSelections = displayData.reportSelections || initialReportSelections;


  // In PDFPreviewPage.jsx, update the safeReportSelections to properly handle arrays:
const safeReportSelections = {
  COUNTRY: reportSelections?.COUNTRY 
    ? (typeof reportSelections.COUNTRY === 'object' 
        ? reportSelections.COUNTRY.name || reportSelections.COUNTRY.label || reportSelections.COUNTRY.value || "--"
        : reportSelections.COUNTRY)
    : "--",
  REGION: reportSelections?.REGION
    ? (typeof reportSelections.REGION === 'object'
        ? reportSelections.REGION.name || reportSelections.REGION.label || reportSelections.REGION.value || "--"
        : reportSelections.REGION)
    : "--",
  DISTRICT: reportSelections?.DISTRICT
    ? (typeof reportSelections.DISTRICT === 'object'
        ? reportSelections.DISTRICT.name || reportSelections.DISTRICT.label || reportSelections.DISTRICT.value || "--"
        : reportSelections.DISTRICT)
    : "--",
  MUNICIPALITY: reportSelections?.MUNICIPALITY || "--",
  SMMEs: typeof reportSelections?.SMMEs === 'object' 
    ? reportSelections.SMMEs.label || reportSelections.SMMEs.value || "--"
    : reportSelections?.SMMEs || "--",
  "VALUE CHAIN": Array.isArray(reportSelections?.["VALUE CHAIN"])
    ? reportSelections["VALUE CHAIN"].map(v => 
        typeof v === 'object' ? v.label || v.value || v : v
      ).join(', ') || "--"
    : reportSelections?.["VALUE CHAIN"] || "--",
    "TYPE OF FARMING": Array.isArray(reportSelections?.["TYPE OF FARMING"])
    ? reportSelections["TYPE OF FARMING"].map(v => 
        typeof v === 'object' ? v.label || v.value || v : v
      ).join(', ') || "--"
    : reportSelections?.["TYPE OF FARMING"] || "--",
  "USER TYPE": reportSelections?.["USER TYPE"] || "--"
};
  const SMMEsOptions = [
    {
      heading: "Agriculture and Agri business",
      items: [  
        { label: "Smallholder farms", value: "SMF" },
        { label: "Agro-processing", value: "AGP" },
        { label: "Agri-input suppliers", value: "AIP" },
        { label: "Horticulture businesses", value: "HCB" },
        { label: "Poultry", value: "POF" },
        { label: "Fish farms", value: "FIF" },
        { label: "Agri-tech startups", value: "ATC" }
      ]
    }
  ];
  // Combine all membership sources safely
const allMemberships = [
  ...(safeMembershipData.selected || []).map(item => 
    typeof item === 'string' ? item : item.value || item.label || item.membershipId || 'Membership'
  ),
  ...(safeMembershipData.custom || []).map(item => 
    typeof item === 'string' ? item : item.value || item.label || 'Custom Membership'
  ),
  ...(safeMembershipData.customInputBoxes || []).map(box => 
    typeof box === 'string' ? box : box.value || 'Custom Box'
  ),
  // Include input values from membershipInputs
  ...(safeMembershipData.inputs ? Object.values(safeMembershipData.inputs).filter(Boolean) : [])
].filter(Boolean);
  const boxPlaceholders = [
    "XXXXXXX",
    "XXXXXXX",
    "XXXXXXX",
    "XXXXXXX",
    "XXXXXXX",
    "XXXXXXX",
    "XXXXXXX",
    "XXXXXXX",
  ];

  const handleSearch = async () => {
    try {
      setIsLoading(true);
      setSearchError('');
      
      if (!searchTerm.trim()) {
        setSearchError('Please enter a registration number');
        setIsLoading(false);
        return;
      }
      
      const registrationsRef = collection(db, 'registrations');
      const q = query(
        registrationsRef, 
        where('registrationNumber', '==', searchTerm.trim().toUpperCase())
      );
      
      const querySnapshot = await getDocs(q);
      
      if (querySnapshot.empty) {
        setSearchError('No registration found with that number');
        setSearchResults(null);
        setIsLoading(false);
        return;
      }
      
      const doc = querySnapshot.docs[0];
      const data = doc.data();
      
      // Format the data similar to how Document page expects it
      setSearchResults({
        ...data,
        personalInfo: data.personalInfo || {},
        organizationInfo: data.organizationInfo || {},
        landData: data.landData || {},
        membershipData: {
          selected: data.membershipData?.selected || [],
          custom: data.membershipData?.custom || '',
          customInputBoxes: data.membershipData?.customInputBoxes || [],
          inputs: data.membershipData?.inputs || {}
        },
        groupExperience: data.groupExperience || [],
        dataPermissions: data.dataPermissions || [],
        focusSelected: data.sectionD?.focusSelected || [],
        industry: {
          selectedChallenges: data.industry?.selectedChallenges || [],
          vision: data.industry?.vision || ''
        },
        productBoxValues: data.productBoxValues || Array(8).fill({
          minOrder: 0,
          minOrderUnit: 'Kg',
          size: 'Regular',
          farmGatePrice: 0,
          farmGatePriceUnit: 'Kg'
        }),
        sectionD: data.sectionD || {},
        setaQualification: data.setaQualification || {},
        profileImage: data.profileImage ? {
          url: data.profileImage.url || data.profileImage.previewUrl || data.profileImage.cloudinaryUrl || '',
          previewUrl: data.profileImage.previewUrl || '',
          cloudinaryUrl: data.profileImage.cloudinaryUrl || ''
        } : null,
        productImages: (data.productImages || []).map(img => ({
          url: img.url || img.previewUrl || img.cloudinaryUrl || '',
          previewUrl: img.previewUrl || '',
          cloudinaryUrl: img.cloudinaryUrl || '',
          documentType: img.documentType || 'Product Image'
        })),
        certificatesUrls: (data.certificatesUrls || []).map(cert => ({
          url: cert.url || cert.previewUrl || cert.cloudinaryUrl || '',
          previewUrl: cert.previewUrl || '',
          cloudinaryUrl: cert.cloudinaryUrl || '',
          documentType: cert.documentType || cert.type || 'Certificate'
        })),
        idDocumentUrl: data.organizationInfo?.idDocument || '',
        registrationNumber: data.registrationNumber || '',
        formData: data.personalInfo || {},
        orgFormData: data.organizationInfo || {},
        personData: data.personData || {}
      });
      
    } catch (error) {
      console.error('Search error:', error);
      setSearchError('Error searching for registration');
    } finally {
      setIsLoading(false);
    }
  };
  const [isPrintReady, setIsPrintReady] = useState(false);
  console.log('Membership data for PDF:', {
    selected: safeMembershipData.selected,
    custom: safeMembershipData.customInputBoxes,
    customInputBoxes: membershipData.customInputBoxes
  });
  const processedProducts = productImages.map((img, index) => {
    if (!img) return { loaded: false, url: null, documentType: boxPlaceholders[index] };
    
    const url = img.cloudinaryUrl || img.url || img.previewUrl || null;
    return { 
      loaded: !!url, 
      url,
      documentType: img.documentType || boxPlaceholders[index] 
    };
  });
  useEffect(() => {
    const processImages = async () => {
      try {
        // Process profile image
        let profileUrl = null;
        if (profileImage) {
          profileUrl = profileImage.cloudinaryUrl || profileImage.url || profileImage.previewUrl || null;
        }
  
        // Process product images with fallbacks
        const processedProducts = productImages.map((img, index) => {
          const url = img.cloudinaryUrl || img.url || img.previewUrl || null;
          return {
            loaded: !!url,
            url,
            documentType: img.documentType || productBoxValues[index]?.documentType || boxPlaceholders[index]
          };
        });
  
        // Process certificates
        const processedCertificates = certificatesUrls.map(cert => {
          const url = cert.cloudinaryUrl || cert.url || cert.previewUrl || null;
          return {
            loaded: !!url,
            url,
            documentType: cert.documentType || cert.type || 'Certificate'
          };
        });
  
        setImageStatus({
          profile: { loaded: !!profileUrl, url: profileUrl },
          products: processedProducts,
          certificates: processedCertificates
        });
        
        setIsPrintReady(true);
      } catch (error) {
        console.error('Error processing images:', error);
        // Set fallback image status
        setImageStatus({
          profile: { loaded: false, url: null },
          products: productImages.map(() => ({ loaded: false, url: null })),
          certificates: certificatesUrls.map(() => ({ loaded: false, url: null }))
        });
      }
    };
    
    if (profileImage || productImages.length > 0 || certificatesUrls.length > 0) {
      processImages();
    }
  }, [profileImage, productImages, certificatesUrls]);
  const formatDate = (dateString) => {
    if (!dateString) return 'Not provided';
    
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return 'Invalid date';
      
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    } catch (e) {
      console.error('Date formatting error:', e);
      return 'Invalid date';
    }
  };
  const handleDownloadPDF = async () => {
    if (!pdfRef.current) {
      console.error('No content to print');
      return;
    }
  
    setIsDownloading(true);
    setPdfDownloaded(false);
    
    try {
      const element = pdfRef.current;
      
      // Store original styles to restore later
      const originalStyles = {
        overflow: element.style.overflow,
        height: element.style.height,
        width: element.style.width,
      };
      
      // Make element full size for capture
      element.style.overflow = 'visible';
      element.style.height = 'auto';
      element.style.width = '100%';
  
      // Hide elements that shouldn't be printed
      const noPrintElements = document.querySelectorAll('.no-print');
      noPrintElements.forEach(el => {
        el.style.visibility = 'hidden';
      });
  
      // Show loading indicator
      const loadingIndicator = document.createElement('div');
      loadingIndicator.style.position = 'fixed';
      loadingIndicator.style.top = '50%';
      loadingIndicator.style.left = '50%';
      loadingIndicator.style.transform = 'translate(-50%, -50%)';
      loadingIndicator.style.backgroundColor = 'rgba(0,0,0,0.7)';
      loadingIndicator.style.color = 'white';
      loadingIndicator.style.padding = '20px';
      loadingIndicator.style.borderRadius = '5px';
      loadingIndicator.style.zIndex = '9999';
      loadingIndicator.textContent = 'Generating PDF...';
      document.body.appendChild(loadingIndicator);
  
      // Generate canvas with html2canvas
      const canvas = await html2canvas(element, {
        scale: 1,
        useCORS: true,
        logging: false,
        backgroundColor: '#FFFFFF',
        scrollY: -window.scrollY,
        windowHeight: element.scrollHeight,
        ignoreElements: (el) => el.style.visibility === 'hidden'
      });
  
      // Clean up
      document.body.removeChild(loadingIndicator);
      noPrintElements.forEach(el => {
        el.style.visibility = '';
      });
      Object.assign(element.style, originalStyles);
  
      // Create PDF with full content height
      const pdf = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: [canvas.width * 0.264583, canvas.height * 0.264583]
      });
  
      // Add image to PDF (full size)
      pdf.addImage(
        canvas.toDataURL('image/jpeg', 0.85),
        'JPEG',
        0,
        0,
        pdf.internal.pageSize.getWidth(),
        pdf.internal.pageSize.getHeight()
      );
  
      // Save the PDF
      pdf.save(`Registration_${registrationNumber || 'Document'}.pdf`);
      setPdfDownloaded(true);
      
    } catch (error) {
      console.error('PDF generation error:', error);
      alert(`Failed to generate PDF: ${error.message}`);
      setPdfDownloaded(false);
    } finally {
      setIsDownloading(false);
    }
  };
  console.log('Received productBoxValues:', productBoxValues);
  console.log('Full location state:', location.state);
  console.log('Passing membership data to document page:', {
    selected: safeMembershipData.selected,
    custom: safeMembershipData.customInputBoxes,
    customInputBoxes: safeMembershipData.customInputBoxes,
    inputs: safeMembershipData.inputs
  });
  // Add this at the top of PDFPreviewPage.jsx
const calculateFinalPrice = (basePrice) => {
  const markup = basePrice * 0.05; // 5% markup
  return Math.round((basePrice + markup) * 100) / 100; // Round to 2 decimal places
};
const currencySymbol = selectedCountry?.currency || 'R'; // Default to 'R' if no currency found
// When processing certificates for the PDF:
// In PDFPreviewPage.jsx, update how certificates are processed
const processedCertificates = certificatesUrls.map(cert => {
  // Handle both old and new certificate formats
  const url = cert.cloudinaryUrl || cert.url || cert.previewUrl || '';
  const documentType = cert.documentType || cert.type || 'Unknown Document Type';
  
  return {
    url,
    documentType,
    type: documentType // For backward compatibility
  };
});
console.log('Original product images:', productImages);
console.log('Processed product images:', imageStatus.products);
  const [selectedService, setSelectedService] = useState(null);

  return (
    <div className="bg-gray-100 p-4 md:p-8">
      <div className="md:px-10">
        {/* Search and Header Section - Not included in PDF */}
        <div className='p-4 md:p-10 no-print'>
  <div className="flex justify-between items-center">
    <h2 className="md:text-[36px] text-[10px] capitalize text-[#152C24] font-bold">
      <span className="text-[#979797] capitalize">SERVICES | </span>{selectedCountry?.name || 'South Africa'}
    </h2>
    <div>
      <h1 className="md:text-[20px] text-[8px] font-extrabold md:mb-2">USER NUMBER</h1>
      <div className="flex w-fit">
        <button
          className={`xl:w-[250px] lg:w-[160px] md:w-[90px] w-[70px] h-[20px] md:h-[53px] bg-[#152C24] text-white font-medium flex items-center px-1 rounded-l-[5px]`}>
          <input className="md:text-[18px] text-[8px] md:px-2 bg-transparent outline-none placeholder-white" placeholder="XXXXXXXXX"/>
        </button>
        <div
          className="w-[16px] h-[20px] md:h-[53px] md:w-[50px] bg-[#EEB527] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer"
        >
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747251939/Expand_right_wbmjno.png"
            alt="expand"
            className="w-3 h-[10px] md:w-6 md:h-[24px]"
          />
        </div>
      </div>
      <p className="md:text-[14px] text-[6px] font-normal mt-1 text-black">
        Insert ID Number
      </p>
    </div>
  </div>
  
  <div className="flex items-center w-full md:mb-10 md:mt-6 mb-2 gap-4 md:gap-12">
    <div>
      <h1 className="md:text-[32px] font-bold text-[10px]">Services</h1>
      <Dropdown 
        type="SERVICES" 
        value={selectedService} 
        onSelect={(option) => setSelectedService(option)}
      />
    </div>
    
    <div className="flex-1 relative md:mt-10">
  <input
    placeholder="Enter registration number to verify information"
    type="text"
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
    className="w-full md:h-[61px] h-[25px] text-[#979797] text-[8px] md:text-[16px] font-semibold md:p-3 pr-8 p-1 md:px-6 px-3 border border-[#C4C4C4] md:rounded-md rounded-full focus:outline-none focus:ring-2 focus:ring-green-600"
  />
  <img
    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744490602/Search_k7vxkr.png"
    alt="Search Icon"
    className="w-[12px] h-[12px] md:h-[24px] md:w-[24px] absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
    onClick={handleSearch}
  />
  {searchError && (
    <p className="text-red-500 text-xs mt-1">{searchError}</p>
  )}
  {isLoading && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white p-4 rounded-lg">
      <p>Searching for registration...</p>
    </div>
  </div>
)}
</div>
  </div>

  {/* Added extra spacing container */}
  <div className="md:h-[20px] h-[10px]"></div>

  <div className='md:mt-5'>
    <h2 className="md:text-[40px] text-center text-[10px] capitalize text-[#152C24] font-bold md:mt-14 mb-2">
      <span className="text-[#979797] capitalize">VERIFICATION | </span>UNIQUE USER REGISTRATION
    </h2>
    <div className="md:mt-5 md:mb-5 flex justify-between items-center">
      <div>
        <h1 className="md:text-[20px] text-[6px] text-black font-extrabold md:mb-2">COUNTRY</h1>
        <div className="flex w-fit md:mt-3">
          <button className={`xl:w-[200px] lg:w-[140px] md:w-[90px] w-[50px] h-[15px] md:h-[53px] bg-[#2E453D] text-white font-medium flex items-center px-1 rounded-l-[5px]`}>
            <span className="md:text-[18px] md:px-2 text-[4px] md:mt-0 mt-[2px] truncate">
              {selectedCountry.name.toUpperCase() || "SOUTH AFRICA"}
            </span>
          </button>
          <div className="w-[15px] h-[15px] md:h-[53px] md:w-[70px] bg-[#152C24] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer">
            <span className="md:text-[18px] md:px-2 text-[4px] md:mt-0 mt-[2px] truncate font-medium">
              {selectedCountry.code || "27"}
            </span>
          </div>
        </div>
        <p className="md:text-[14px] text-[4px] font-normal mt-1 text-black">
          Select country flag to change country
        </p>
      </div>
      <div>
        <h1 className="md:text-[20px] text-[6px] text-white font-extrabold md:mb-2">COUNTRY</h1>
        <div className="flex w-full">
          <button 
            className={`w-full md:w-[250px] h-5 md:h-[50px] bg-[#2E453D] text-white font-bold flex items-center md:px-1 rounded-l-[5px]`}
            onClick={() => setShowSharePopup(true)}
          >
            <div className="text-[4px] md:text-[16px] px-0 text-center md:px-2 bg-transparent outline-none w-full">SHARE REGISTRATION</div>
          </button>
          <div 
            className="w-5 h-5 md:h-[50px] md:w-[50px] bg-[#FDBB26] text-white flex justify-center items-center rounded-r-[5px] -ml-1 z-30 cursor-pointer"
            onClick={() => setShowSharePopup(true)}
          >
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747251939/Expand_right_wbmjno.png"
              alt="expand"
              className="w-3 h-3 md:w-6 md:h-[24px]"
            />
          </div>
        </div>
        <p className="text-[6px] md:text-[14px] font-normal mt-1 text-black">
          Save registration 
        </p>
      </div>
    </div>
  </div>
  
  <div className='md:h-[1px] bg-black  w-full mt-2 mb-2'></div>
  
  <div className='flex flex-row justify-between items-center mt-3 md:mt-5 gap-2'>
    <img 
      src='https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752864890/FarmNet_Logo_Green_4_p1r5j5.png' 
      alt="Logo" 
      className='h-4 md:h-[60px]'
    />
    <div className="flex-1 text-center">
      <h1 className="text-lg md:text-[54px] font-extrabold text-black">
        REGISTRATION
      </h1>
    </div>
    {selectedCountry && (
      <div className="flex flex-col items-end">
        <img
          src={selectedCountry.flag}
          alt={selectedCountry.name}
          className="w-8 h-6 md:w-20 md:h-14 border"
        />
        <span className="text-xs mt-2 md:text-[20px] italic text-left font-normal w-full">
          {selectedCountry.name}
        </span>
      </div>
    )}
  </div>
</div>

        {/* PDF Content */}
        <div 
          ref={pdfRef} 
          className="w-full mx-auto  print-container"
          style={{
            overflow: 'visible',
            height: 'auto',
            width: '100%',
            padding: 0,
            margin: 0
          }}
        >
          <div className='p-4 md:p-10 print:p-2'>
            {/* User Registration Information */}
            <div className="flex md:flex-row justify-between items-center mb-6 md:mb-8  print:mb-4">
              <div className="w-full md:w-1/2 mb-4 md:mb-0 md:-mt-4 print:w-1/2">
                <h2 className="text-[12px] md:text-[32px] font-bold print:text-[20px]">
                  {safeFormData.firstName || 'First Name'} {safeFormData.surname || 'Surname'}
                </h2>
                <p className="text-[6px] md:text-[24px] md:mt-[11px] font-semibold print:text-[14px]">
                  <span className='text-[#979797]'>ID No:</span> {registrationNumber || 'Not provided'}
                </p>
                <div className='h-0.5 md:h-[2px] bg-[#979797]/70 md:flex hidden mt-[12px] print:hidden'></div>
                <p className="text-[6px] md:text-[20px] text-[#152C24] font-semibold md:mt-2 print:text-[12px]">Mobile: {safeFormData.mobile || 'Not provided'}</p>
                <p className="text-[6px] md:text-[20px] text-[#152C24] font-semibold print:text-[12px]">Email: {safeFormData.email || 'Not provided'}</p>
                <p className="text-[6px] md:text-[20px] text-[#152C24] font-semibold print:text-[12px]">Location: {safeFormData.physicalAddress || 'Not provided'}</p>
                <p className="text-[6px] md:text-[20px] text-[#152C24] font-semibold print:text-[12px]">Date: {formatDate(new Date().toISOString())}</p>
              </div>
              <div className="flex flex-col-reverse md:flex-row items-end gap-2 print:flex-col">
                <div className="print:text-[10px]">
                  <div className='h-0.5 md:h-[2px] bg-[#979797]/70 md:flex hidden print:hidden -mt-2'></div>
                  <p className="text-[6px] md:text-[18px] text-[#979797] tracking-wider leading-snug md:leading-[1.80] font-light text-left md:max-w-[500px] mt-2 md:mt-6 print:text-[10px] print:mt-2">
                    To ensure this registration is authentic, scan the QR Code and verify against original information and report
                  </p>
                </div>
                <img 
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751138385/WhatsApp_Image_2025-06-28_at_10.55.30_PM_kprooh.jpg" 
                  alt="QR Code" 
                  className="w-16 h-16 md:w-[200px] md:h-[200px] mb-2 print:w-[100px] print:h-[100px]"
                />
              </div>
            </div>
            
            <div className="mb-6 md:mb-8 print:mb-4 relative">
  {imageStatus.profile.loaded && imageStatus.profile.url ? (
    <div className="w-full h-64 md:h-[450px] border border-gray-300 overflow-hidden print:h-[600px] relative">
      <img 
        src={imageStatus.profile.url} 
        alt="Profile" 
        className="w-full h-full object-cover"
        crossOrigin="anonymous"
        onError={(e) => {
          console.error('Error loading profile image:', imageStatus.profile.url);
          // Fallback to placeholder if image fails to load
          e.target.onerror = null;
          e.target.src = 'https://via.placeholder.com/600x400?text=Profile+Image+Not+Available';
          setImageStatus(prev => ({
            ...prev,
            profile: { ...prev.profile, loaded: false }
          }));
        }}
      />
      {/* Logo in bottom-left corner */}
      <img 
        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751323883/image_1716_c16u5d.png"
        alt="Logo"
        className="absolute bottom-2 left-2 w-12 h-12 md:w-40 md:h-20 print:w-16 print:h-16"
      />
    </div>
  ) : (
    <div className="w-full h-64 border border-gray-300 flex items-center justify-center print:h-[300px] bg-gray-100">
      {profileImage ? (
        <div className="text-center">
          <p className='md:text-[30px] text-[8px] print:text-[12px]'>Image loading...</p>
          <p className='md:text-[16px] text-[6px] print:text-[10px] text-gray-500'>
            {imageStatus.profile.url ? 'URL: ' + imageStatus.profile.url : 'No image URL available'}
          </p>
        </div>
      ) : (
        <span className='md:text-[30px] text-[8px] print:text-[12px]'>No profile imagse provided</span>
      )}
    </div>
  )}
</div>

            {/* Individual Information Section */}
            <div className="mb-6 md:mb-8 print:mb-4">
        
              <div className="mt-2 md:mt-4 print:mt-2">
                <ReportsSection 
                  values={safeReportSelections}
                  isPreview={true}
                  smmesOptions={SMMEsOptions}
                  onChange={() => {}}
                  printMode={true}
                />
              </div>
            </div>
            

            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 p-4">
            {imageStatus.products.map((img, index) => {
  const boxValue = productBoxValues[index] || {
    minOrder: 0,
    minOrderUnit: 'Kg',
    size: 'Regular',
    farmGatePrice: 0,
    farmGatePriceUnit: 'Kg',
    documentType: img.documentType || boxPlaceholders[index]
  };

  return (
    <div key={index}>
      <div className="text-[8px] md:text-[16px] px-2 py-1 rounded z-10">
        {boxValue.documentType || img.documentType || boxPlaceholders[index]}
      </div>
      <div className="relative bg-[#D9D9D9] rounded-[5px] h-20 md:h-[350px] w-full overflow-hidden">
      {img.loaded ? (
      <img
        src={img.url}
        alt={`Product ${index + 1}`}
        className="object-cover opacity-90 w-full h-full"
        crossOrigin="anonymous"
        onError={(e) => {
          console.error('Error loading product image:', img.url);
          e.target.onerror = null;
          e.target.src = 'https://via.placeholder.com/300x200?text=Image+Not+Available';
          // Update image status
          setImageStatus(prev => {
            const newProducts = [...prev.products];
            newProducts[index] = { ...newProducts[index], loaded: false };
            return { ...prev, products: newProducts };
          });
        }}
      />
    ) : (
      <div className="flex items-center justify-center h-full bg-gray-100">
        <span className="text-gray-500">No image available</span>
      </div>
    )}
        {/* Product details overlay */}
        <div className="absolute bottom-0 left-0 right-0 p-2 rounded-b-[5px] bg-gradient-to-t from-black/80 to-transparent">
          {/* Minimum Order Section */}
          <div className="mb-2">
            <label className="text-black text-xs font-normal block mb-1">Minimum Order</label>
            <div className="flex items-center gap-1">
              <div className="flex-1 flex bg-white/10 rounded-l overflow-hidden">
                <div className="w-3/4 flex items-center justify-center text-black text-xs py-1">
                  {boxValue.minOrderUnit || 'Kg'}
                </div>
              </div>
              <div className="flex-1 bg-white/10 text-black text-xs py-1 rounded-r text-center">
                {boxValue.minOrder || '0'}
              </div>
            </div>
          </div>

          {/* Size Section */}
          <div className="mb-2 w-3/6">
            <label className="text-black  text-xs font-normal block mb-1">Size</label>
            <div className="flex items-center gap-1">
              <div className="flex-1 flex justify-center items-center bg-white/10 rounded overflow-hidden">
                <div className="flex items-center justify-center text-black text-xs py-1">
                  {boxValue.size || 'Regular'}
                </div>
              </div>
            </div>
          </div>
          
       {/* In PDFPreviewPage.jsx - update the Farm Gate Price section */}
<div>
  <label className=" text-xs font-normal block text-black mb-1">Farm Gate Price</label>
  <div className="flex">
    <div className="flex-1 bg-[#2E453D] text-white text-xs py-1 font-medium text-center rounded-l">
      {boxValue.farmGatePriceUnit || 'Kg'}
    </div>
    <div className="flex-1 bg-[#152C24] text-white text-xs py-1 font-medium text-center rounded-r">
  {currencySymbol} {boxValue.farmGatePrice || '0'}
</div>

  </div>
  <div className="mt-1 text-[10px] text-white/80">
  Final Price (incl. 5% markup): {currencySymbol} {calculateFinalPrice(boxValue.farmGatePrice)}
  </div>
</div>
        </div>
      </div>
   </div>
    );
  })}
</div>

            {/* Documents Section */}
            {imageStatus.certificates.length > 0 && (
              <div className="mb-6 md:mb-8 mt-6 print:mb-4 print:mt-4">
                <h2 className="text-[8px] md:text-[36px] font-bold text-black  print:text-[20px]">DOCUMENTS</h2>
                <div className="grid grid-cols-4 md:grid-cols-4 gap-1.5 md:gap-2 print:grid-cols-2 print:gap-1">
                  {imageStatus.certificates.map((cert, index) => (
                    <div key={index} className="flex flex-col mt-2 md:mt-3 print:mt-2">
                      <p className="text-[8px] md:text-[24px] font-light italic md:mb-3 text-left  md:w-[260px] leading-tight print:text-[12px] print:min-h-[8px]">
                      {cert.documentType || cert.type || 'Document'} {/* Fallback chain */}
                      </p>
                      <div className="relative bg-[#D9D9D9] rounded-[5px] h-20 md:h-[350px] w-full overflow-hidden print:h-[150px]">
                        {cert.url ? (
                          <img
                            src={cert.url}
                            alt={`Certificate ${index + 1}`}
                            className="object-cover w-full h-full"
                            crossOrigin="anonymous"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = 'data:image/svg+xml;base64,...';
                            }}
                          />
                        ) : (
                          <div className="flex items-center justify-center h-full">
                            <span className="print:text-[10px]">No certificate available</span>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            <hr/>
            <div className="mb-6 md:mb-8 md:mt-4 mt-2 print:mb-4">
  <h2 className="text-[8px] md:text-[36px] font-bold text-black print:text-[20px]">PERSON</h2>
  
  <div className="grid grid-cols-2 md:grid-cols-2 gap-1 md:gap-y-5 mt-3">
    {['Male', 'Female', 'Youth', 'Physical'].map((option, i) => {
      const isLastItem = i === 3; // Disability is the last item
      const isSelected = 
        (!isLastItem && personData.gender === option) || 
        (isLastItem && personData.disability);
      
      return (
        <div
          key={i}
          className={`flex items-center justify-between w-full h-[25px] md:h-[71px] bg-[#E7EBEB] border rounded px-2 print:h-[40px] ${
            isLastItem ? 'relative' : ''
          }`}
        >
          <span className="font-bold text-[6px] md:text-[28px] print:text-[12px]">
            {option}
          </span>
          
          <span
            className={`md:w-[55px] md:h-[55px] h-[22px] w-[22px] rounded-full ${
              isSelected 
                ? 'bg-[#152C24] md:border-[6px] border-[4px] border-white print:border-[3px]' 
                : 'md:border-[6px] border-[4px] border-white bg-[#D9D9D9] print:border-[3px]'
            }`}
          />

          {isLastItem && personData.disability && (
            <div className="absolute left-0 right-0 top-full mt-1 z-10 md:w-[300px] bg-white border border-gray-200 rounded-md shadow-lg py-1 print:shadow-none">
              <div className="px-2 py-1 font-bold flex justify-between text-[6px] md:text-[16px] print:text-[10px]">
                {personData.disability}
                <div className={`w-2 h-2 md:w-4 md:h-4 rounded-full bg-[#152C24]`}></div>
              </div>
            </div>
          )}
        </div>
      );
    })}
  </div>
</div>
            {/* Land Information Section */}
            <div className="mb-6 md:mb-8 print:mb-4">
  <h2 className="text-[8px] md:text-[36px] font-bold text-black mb-3 md:mb-4 print:text-[20px]">LAND DESIGNATED FOR AGRICULTURAL USE</h2>
  <div className="space-y-1 md:space-y-2 print:space-y-1">
    {/* Land Type 1 */}
    {safeLandData.type1?.type && (
      <div className="flex print:h-[40px]">
        <div className="bg-[#CFD7D7] border-b-[1px] border-[#000000] h-12 md:h-[80px] rounded-l-[5px] w-1/2 flex items-center px-2 md:px-4 print:h-[40px] print:px-2">
          <span className="text-[8px] md:text-[32px] print:text-[14px] font-medium">{safeLandData.type1.type}</span>
        </div>
        <div className="relative bg-[#E7EBEB]   border-b-[1px] border-[#000000]  h-12 md:h-[80px] rounded-r-[5px] w-1/2 flex items-center justify-center print:h-[40px]">
          <span className="text-black text-[8px] md:text-[36px] underline print:text-[14px] font-medium">
            {safeLandData.type1.size ? 
              `${safeLandData.type1.size} ${safeLandData.type1.unit || ''}` : 
              'Not provided'}
          </span>
          <span className="absolute bottom-2 right-1 md:right-4 text-black font-bold text-[8px] md:text-[28px] print:text-[12px] print:bottom-4 print:right-2">
            HA
          </span>
        </div>
      </div>
    )}

    {/* Land Type 2 */}
    {safeLandData.type2?.type && (
      <div className="flex print:h-[40px]">
        <div className="bg-[#CFD7D7] border-b-[1px] border-[#000000]   h-12 md:h-[80px] rounded-l-[5px] w-1/2 flex items-center px-2 md:px-4 print:h-[40px] print:px-2">
          <span className="text-[8px] md:text-[32px]  print:text-[14px] font-medium">{safeLandData.type2.type}</span>
        </div>
        <div className="relative bg-[#E7EBEB] h-12 md:h-[80px] rounded-r-[5px] w-1/2 flex items-center justify-center print:h-[40px]">
          <span className="text-black text-[8px] md:text-[36px] underline print:text-[14px] font-medium">
            {safeLandData.type2.size ? 
              `${safeLandData.type2.size} ${safeLandData.type2.unit || ''}` : 
              'Not provided'}
          </span>
          <span className="absolute bottom-2 right-1 md:right-4 text-black font-bold text-[8px] md:text-[24px] print:text-[12px] print:bottom-4 print:right-2">
            HA
          </span>
        </div>
      </div>
    )}
    
    {/* Land Registration */}
    <div className="flex print:h-[40px]  border-b-[1px] border-[#000000]  ">
      <div className="bg-[#CFD7D7] h-12  md:h-[80px] rounded-l-[5px] w-1/2 flex items-center px-2 md:px-4 print:h-[40px] print:px-2">
        <span className="text-[8px] md:text-[32px]  print:text-[14px] font-medium">LAND REGISTRATION NUMBER</span>
      </div>
      <div className="bg-[#E7EBEB] h-12 md:h-[80px] rounded-r-[5px] w-1/2 flex items-center justify-center print:h-[40px]">
        <span className="text-black text-[8px] md:text-[36px]  underline print:text-[14px] font-medium">
          {safeLandData.erfNumber || 'Not provided'}
        </span>
      </div>
    </div>
  </div>
</div>

{/* Membership Section */}
{/* Membership Section */}
<div className="mb-6 md:mt-16 mt-2">
  <h2 className="text-[8px] md:text-[36px] font-bold text-black mb-3 md:mb-4 print:text-[20px]">MEMBERSHIPS | AFFILIATIONS | GROUPS | ASSOCIATIONS</h2>
  
  {/* Container for membership pairs */}
  <div className="space-y-2">
    {/* First render selected memberships with their corresponding custom inputs */}
    {safeMembershipData.selected && safeMembershipData.selected.map((membership, index) => (
      <div>
  <div  key={`membership-pair-${index}`} >
        <button
          className="w-full relative md:h-[71px] h-[20px] flex items-center justify-between px-4 rounded-[5px] cursor-pointer bg-[#2E453D] text-white"
        >
          <span className="text-white text-[8px] md:text-[32px] print:text-[14px] font-medium">
          {typeof membership === 'string' ? membership : membership.label || membership.value || 'MEMBERSHIP'}
          </span>
          <div
            className="absolute top-0 right-0 w-[20px] h-[20px] md:h-full md:w-[85px] bg-[#152C24] text-white flex justify-center items-center rounded-r-[5px] cursor-pointer"
            onClick={(e) => e.stopPropagation()}
          >
          
          </div>
        </button>
   <div className="flex print:h-[40px] md:mt-5 mt-2">
     {/* Left side - Membership name */}
     <div className="bg-[#CFD7D7] h-12 md:h-[80px] rounded-l-[5px] md:w-[600px] w-[180px] flex items-center px-2 md:px-4 print:h-[40px] print:px-2">
          <span className="text-[8px] md:text-[32px] print:text-[14px] font-medium">
            {typeof membership === 'string' ? membership : membership.label || membership.value || 'MEMBERSHIP'}
          </span>
        </div>
        
        {/* Right side - Corresponding custom input */}
        <div className="bg-[#E7EBEB] h-12 md:h-[80px] rounded-r-[5px] w-full flex items-center justify-center print:h-[40px]">
          <span className="text-black text-[8px] md:text-[36px] underline print:text-[14px] font-medium">
            {safeMembershipData.custom && safeMembershipData.custom[index] 
              ? (typeof safeMembershipData.custom[index] === 'string' 
                  ? safeMembershipData.custom[index] 
                  : safeMembershipData.custom[index].value || 'CUSTOM MEMBER')
              : 'Not provided'}
          </span>
        </div>
   </div>
  </div>
      </div>
    ))}
    
    {/* Then render any remaining custom inputs that don't have corresponding selected memberships */}
    {safeMembershipData.custom && 
     safeMembershipData.custom.length > (safeMembershipData.selected?.length || 0) && 
     safeMembershipData.custom.slice(safeMembershipData.selected?.length || 0).map((custom, index) => (
      <div key={`extra-custom-${index}`} className="flex print:h-[40px] border-b-[1px] border-[#000000]">
        {/* Left side empty for custom inputs without selected membership */}
        <div className="bg-[#CFD7D7] h-12 md:h-[80px] rounded-l-[5px] w-1/2 flex items-center px-2 md:px-4 print:h-[40px] print:px-2">
          <span className="text-[8px] md:text-[32px] print:text-[14px] font-medium">
            CUSTOM MEMBERSHIP
          </span>
        </div>
        
        {/* Right side - Custom input value */}
        <div className="bg-[#E7EBEB] h-12 md:h-[80px] rounded-r-[5px] w-1/2 flex items-center justify-center print:h-[40px]">
          <span className="text-black text-[8px] md:text-[36px] underline print:text-[14px] font-medium">
            {typeof custom === 'string' ? custom : custom.value || 'CUSTOM MEMBER'}
          </span>
        </div>
      </div>
    ))}
    
    {/* No memberships message */}
    {(!safeMembershipData.selected || safeMembershipData.selected.length === 0) && 
     (!safeMembershipData.custom || safeMembershipData.custom.length === 0) && (
      <p className="text-[6px] md:text-[24px] text-gray-500 print:text-[12px]">
        No memberships selected
      </p>
    )}
  </div>
</div>
 

            {/* Experience Section */}
            <div className="mb-6 md:mb-8 md:mt-16 print:mb-4 print:mt-10">
              <h2 className="text-[8px] md:text-[36px] font-bold mb-2 print:text-[20px]">EXPERIENCE </h2>
              <ul>
                {groupExperience && groupExperience.length > 0 ? (
                  groupExperience.map((exp, index) => (
                    <li key={index} className="text-[6px] md:text-[36px] md:mt-3 mt-2 print:text-[14px] print:mt-2">{exp}</li>
                  ))
                ) : (
                  <li className="text-[6px] md:text-[36px] print:text-[14px]">Not provided</li>
                )}
              </ul>
            </div>

      

            {/* Industry Activity Survey */}
            <div className="mb-6 md:mb-10 md:mt-10 print:mb-4 print:mt-5">
              <h2 className="text-[8px] md:text-[36px] font-bold text-black mb-3 md:mb-4 print:text-[20px]">INDUSTRY ACTIVITY SURVEY</h2>
              <p className="text-[6px] md:text-[32px] font-normal leading-[0.90] mb-2 text-[#979797] print:text-[14px]">
                What would you like to achieve (your vision and goals) in your enterprise pursuits and activities?
              </p>
              <p className="text-[6px] md:text-[36px] font-bold mb-4 md:mb-6 mt-3 print:text-[14px] print:mt-4">{safeIndustry.vision}</p>

              {/* Challenges Section */}
              <div>
                <h3 className="text-[8px] md:text-[32px] font-bold mb-3 md:mb-4 md:mt-10 print:text-[18px] print:mt-10">INDUSTRY ACTIVITY SURVEY - CHALLENGES</h3>
      
                {safeIndustry.selectedChallenges && safeIndustry.selectedChallenges.length > 0 ? (
                  <div className="space-y-2 md:space-y-4 print:space-y-2">
                    {safeIndustry.selectedChallenges.map((challenge, index) => (
                      <div key={index} className="">
                        <h4 className="text-[8px] md:text-[28px] font-bold">{challenge.title}</h4>
                        <p className="text-[6px] md:text-[24px] mt-1 md:mt-2">{challenge.description}</p>
                        <p className="text-[6px] md:text-[24px] mt-1 md:mt-2 text-[#2E453D] font-medium">
                          {challenge.solution}
                        </p>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-[6px] md:text-[24px]">No challenges selected</p>
                )}
              </div>
            </div>
{/* Data Section in PDF Preview */}
{/* Data Section in PDF Preview */}
<div className="mb-6 md:mb-8 print:mb-4">
  <h2 className="text-[8px] md:text-[36px] font-bold text-black print:text-[20px]">DATA</h2>
  <p className="text-[6px] md:text-[32px] italic font-medium md:mt-2 md:mb-4 print:text-[12px]">
  Please choose the registered & verified users within the Farmnet system who are permitted to view your data.
  </p>
  
  <div className="grid grid-cols-2 md:gap-1 gap-1 mt-2 md:mt-4 print:grid-cols-2 print:gap-1">
    {['Country', 'Region', 'SMME', 'Value Chain', 'Type of user', 'Non'].map((option, i) => {
      // Safely check if groupExperience includes the option
      const isSelected = Array.isArray(dataPermissions) && dataPermissions.includes(option);
      
      return (
        <div 
          key={i}
          className={`flex items-center justify-between w-full h-[25px] md:h-[71px] bg-[#E7EBEB] border rounded px-2 print:h-[40px]`}
        >
          <span className="font-bold text-[6px] md:text-[28px] print:text-[12px]">
            {option}
          </span>
          
          <span
            className={`md:w-[55px] md:h-[55px] h-[22px] w-[22px] rounded-full ${
              isSelected 
                ? 'bg-[#152C24] md:border-[6px] border-[4px] border-white' 
                : 'md:border-[6px] border-[4px] border-white bg-[#D9D9D9]'
            } print:border-[3px]`}
          />
        </div>
      );
    })}
  </div>
</div>
            {/* Location Section */}
         {/* Location Section */}
<h1 className="text-[8px] md:text-[36px] font-bold">
  LOCATION
</h1>
<div className="mt-2 md:mt-3 print:mb-6 print:mt-3 flex items-center space-x-2 md:space-x-3">
  <img
    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744662306/image_1570_pnbwi8.png"
    alt=".."
    className="w-4 h-4 md:w-[37px] md:h-[37px]"
  />
  <h1 className="text-sm mt-1 md:text-[36px] font-bold">
    Set Location
  </h1>
<div className="mb-8 print:mb-12"></div> 
<div className="mb-8 md:h-[40px] print:h-[30px]"></div> {/* Added space after location */}
{/* Added space after location */}

</div>
<LocationPicker readOnly />
            
            {/* Disclaimer */}
            <div className="mt-6 md:mt-5 pt-2 md:pt-4">
              <p className="text-[6px] md:text-[24px] leading-[1.20]">
                <span className='text-black font-bold '>Disclaimer: </span>Users are advised to verify all entries independently and consult with their financial or legal advisors before making any decisions based on the information provided. Farmnet shall not be held liable for any loss or damage arising directly or indirectly from the use of or reliance on this statement.
              </p>
            </div>
            
            <a href='/' className='flex justify-end text-[8px] md:text-[24px] mt-3 md:mt-1'>
              Terms & Conditions apply
            </a>
            
            {/* Closing Banner */}
            <div className="bg-[#2E453D] flex md:flex-row items-center justify-between px-2 md:px-4 mt-3 md:mt-1 shadow-black/40 shadow-md h-auto md:h-[110px] py-2 md:py-0">
              <div className="flex items-center">
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748543265/FarmNet_Logo_Green_3_e3louy.png"
                  alt="Ad-Luck Holdings Logo"
                  className="w-20 md:w-[280px] h-4 md:h-[50px] object-contain"
                />
                <span className="text-white font-bold text-[8px] md:text-[24px] font-poppins ml-2 md:ml-4">
                  +254702157000
                </span>
              </div>
              <div>
                <span className="text-white font-bold text-[8px] md:text-[24px] font-poppins">
                  |    www.farmnet.africa
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {showSharePopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-bold">Share Registration</h3>
              <button 
                onClick={() => setShowSharePopup(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <FaTimes />
              </button>
            </div>
            
            {!pdfDownloaded ? (
        <div className="text-center py-4">
          <p className="mb-4">Preparing PDF for sharing...</p>
          <button 
            onClick={handleDownloadPDF}
            className="bg-[#2E453D] text-white px-4 py-2 rounded"
            disabled={isDownloading}
          >
            {isDownloading ? 'Downloading...' : 'Download PDF First'}
          </button>
        </div>
      ) : (
        <>
          <div className="bg-green-100 text-green-800 p-3 rounded-md mb-4 text-center">
            PDF ready for sharing!
          </div>
          
          <div className="grid grid-cols-3 gap-4">
            <button 
              onClick={() => handleShare('whatsapp')}
              className="flex flex-col items-center p-3 hover:bg-gray-100 rounded-lg"
            >
              <FaWhatsapp className="text-green-500 text-3xl mb-2" />
              <span>WhatsApp</span>
            </button>
            <button 
              onClick={() => handleShare('facebook')}
              className="flex flex-col items-center p-3 hover:bg-gray-100 rounded-lg"
            >
              <FaFacebook className="text-blue-600 text-3xl mb-2" />
              <span>Facebook</span>
            </button>
            <button 
              onClick={() => handleShare('twitter')}
              className="flex flex-col items-center p-3 hover:bg-gray-100 rounded-lg"
            >
              <FaTwitter className="text-blue-400 text-3xl mb-2" />
              <span>Twitter</span>
            </button>
            <button 
              onClick={() => handleShare('linkedin')}
              className="flex flex-col items-center p-3 hover:bg-gray-100 rounded-lg"
            >
              <FaLinkedin className="text-blue-700 text-3xl mb-2" />
              <span>LinkedIn</span>
            </button>
            <button 
              onClick={() => handleShare('email')}
              className="flex flex-col items-center p-3 hover:bg-gray-100 rounded-lg"
            >
              <FaEnvelope className="text-gray-600 text-3xl mb-2" />
              <span>Email</span>
            </button>
          </div>
        </>
      )}
    </div>
  </div>
)}
    </div>
  );
};

export default Verification;